export enum ActionVehicle {
    dequeue = 1,
    queue = 2,
    triggerForWeighing = 3,
    validateChecklist = 4,
    checkInVehicle = 5,
    viewDetails = 6,
}
